export const ANONYMOUS_APPEAL_STORAGE_KEY = "anonymousAppealId";
